var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(-18904 -2522)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37823",
    "data-name": "Ellipse 37823",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(18904 2522)",
    fill: "#e3f5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "delete-2",
    "data-name": "delete",
    transform: "translate(18919.723 2535.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858304",
    "data-name": "Path 858304",
    d: "M1.163,18.878V4.706H15.335V18.878a2.3,2.3,0,0,1-.692,1.688,2.234,2.234,0,0,1-1.633.692H3.543a2.3,2.3,0,0,1-1.688-.692A2.3,2.3,0,0,1,1.163,18.878ZM16.553,1.163v2.38H0V1.163H4.152L5.315,0h5.924L12.4,1.163Z",
    fill: "#356f92"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAlert);
export default __webpack_public_path__ + "static/media/DeleteAlert.31b726abf3331efc00139401cfdfcc13.svg";
export { ForwardRef as ReactComponent };